export interface IDropdownOption {
  id: number,
  label: string,
  disabled: boolean
}